<div fxLayout="row" class="full-height">
    <cl-side-filters [lockOpened]="lockOpened" class="min-height">
        <dl-device-detail-filters (getDetail)="getDetail()"
                               [filters]="deviceStatusFilters"
                               [hideFields]="hideFields"
                               (toggleReaderView)="toggleReaderView()">
        </dl-device-detail-filters>
    </cl-side-filters>
    <div *ngIf="detailViewService.data && !loading" class="display-in-columns">
        <dl-module-card *ngFor="let module of detailViewService.data.modules"
                     [module]="module">
        </dl-module-card>
    </div>
    <div fxFlex *ngIf="loading"
         class="loading-animation-container">
        <loading-animation size="large"></loading-animation>
    </div>
</div>
